import { getDateDifference, setCookie, getCookie } from '@sceneio/tools'
import posthog from 'posthog-js'
import { useUserStore } from '../store/storeHooks'
import { useEffect } from 'react'

const TRACKER_RETURNING_USER_COOKIE_NAME = 'tracker:returningUser:v2'

export const useTrackReturningUser = () => {
  const { createdAt } = useUserStore()
  const isCookie = getCookie(TRACKER_RETURNING_USER_COOKIE_NAME) === 'true'

  useEffect(() => {
    if (createdAt && !isCookie) {
      const daysAfterSignup = getDateDifference(
        new Date().toString(),
        createdAt,
      )

      if (daysAfterSignup >= 1) {
        posthog.capture('$set', {
          $set: { returning_user: 1 },
        })
        setCookie(TRACKER_RETURNING_USER_COOKIE_NAME, 'true', 2147483647)
      }
    }
  }, [createdAt])
}
